import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Declaraciones } from '@/shared/model/snp/declaraciones.model';
import { Solicitud } from '@/shared/model/solicitud.model';
import { Component, Prop } from 'vue-property-decorator';
import { required, sameAs } from 'vuelidate/lib/validators';

const validations = {
  declaraciones: {
    declaracionVeracidad: {
      sameAsTrue: sameAs(() => true),
    },
    compromisoActualizacion: {
      sameAsTrue: sameAs(() => true),
    },
    aceptacionPrivacidad: {
      sameAsTrue: sameAs(() => true),
    },
    aceptacionLineamientos: {
      sameAsTrue: sameAs(() => true),
    },
  },
};

@Component({
  validations,
})
export default class DeclaracionesF1 extends ApeironComponent {
  @Prop({ required: true })
  public solicitud!: Solicitud;

  public declaraciones: Declaraciones = new Declaraciones();

  public mounted(): void {
    this.declaraciones = this.solicitud.declaraciones ? this.solicitud.declaraciones : new Declaraciones();
  }

  save(): void {
    this.$emit('submit', { declaraciones: this.declaraciones });
  }
}
